export const DEFAULT_FONT_NAME = "PretendardVariable-v1";
export const DEFAULT_EN_FONT_NAME = "PretendardVariable-v1";
export const DEFAULT_JA_FONT_NAME = "NotoSansJP";
export const DEFAULT_FIXED_FONT_NAME = "InterRegular-ascii";

export const RICH_TEXT_EMPTY_VALUE = "<p><br></p>";

export const TIMER_COUNTDOWN_FORMATS = [
  "dd일",
  "dd일 hh:mm",
  "dd일 hh:mm:ss",
  "hh:mm",
  "hh:mm:ss",
] as const;
